/*
 *
 * ZohoVerify constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/ZohoVerify';

/*
 * @dev defineApiActionTypes a function that
 * return concat base with START,SUCCESS,FAILURE
 */
export const VERIFY_ZOHO = defineApiActionTypes(`${prefix}/VERIFY_ZOHO_START`);
